import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Button, Descriptions, Image} from "antd";
import {BaseImageUrl} from "../../http/http";
import watermark from "../../utils";
import {downLoadImageByUrl, getImageUrlName} from "../../utils/imageUtil";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";

interface PlantDetailProps {
    detail:any;
    index: number
}
const defaultIcon = require("../../image/default-pic.png")

const LibraryDetail:React.FC<PlantDetailProps> = ({detail, index}) => {

    useEffect(()=> {
    }, [])

    const downloadImage = () => {
        downLoadImageByUrl(BaseImageUrl+detail.imgUrl, getImageUrlName(detail.imgUrl));
    }

    return (<Wrapper>
        <Image width={"500px"} src={BaseImageUrl+detail.imgUrl} fallback={defaultIcon}/>
        <InfoWrapper>
            <Button onClick={downloadImage} style={{width:"100px", marginLeft:"35px", marginBottom:"20px"}} type={"primary"}>下载图片</Button>
            <Descriptions style={{marginLeft: "35px"}} title={"采集信息"} size={"middle"} layout={"horizontal"} bordered={true} column={1}>
                <Descriptions.Item label={"物种名"}>{detail.cnName}</Descriptions.Item>
                <Descriptions.Item label={"物种拉丁名"}>{detail.ldName}</Descriptions.Item>
                <Descriptions.Item label={"科名"}>{detail.specCnName}</Descriptions.Item>
                <Descriptions.Item label={"种拉丁名"}>{detail.genLdName}</Descriptions.Item>
                <Descriptions.Item label={"拍摄时间"}>{detail.createtime}</Descriptions.Item>
            </Descriptions>
        </InfoWrapper>
        </Wrapper>);
}

export default LibraryDetail;


const Wrapper = styled.div`
  & {
    display: flex;
    max-height: 800px;
    min-height: 300px;
    overflow: auto;
    flex-direction: row;
    padding: 15px;

    .ant-descriptions.ant-descriptions-bordered .ant-descriptions-item-label {
      background-color: #F9FAFD;
    }

    .ant-descriptions .ant-descriptions-item-content {
      color: #666666;
    }
  }
`;
const InfoWrapper = styled.div`

  & {
    display: flex;
    flex-direction: column;
  }
`;